import axios from 'axios';
import AppConfig from "../../../AppConfig";

let URL = AppConfig.HOST_API() + 'bok/oceny/';
let URLCLIENT = AppConfig.HOST_CLIENT_API() + 'auth/bok/oceny/';

export default {

    pobierzWszystkieOceny() {
        return axios({
            method: 'get',
            url: URL,
        });
    },

    pobierzOcenySzczegolowe(dataod, datado, trasa) {
        return axios({
            method: 'get',
            url: Boolean(trasa) ? URL + 'szczegolowe?dataOd=' + dataod + '&dataDo=' + datado + '&idTr=' + trasa : URL + 'szczegolowe?dataOd=' + dataod + '&dataDo=' + datado,
        });
    },

    pobierzOcenyKierowcow(dataod, datado, trasa) {
        return axios({
            method: 'get',
            url: Boolean(trasa) ? URL + 'kierowcow?dataOd=' + dataod + '&dataDo=' + datado + '&idTr=' + trasa : URL + 'kierowcow?dataOd=' + dataod + '&dataDo=' + datado,
        });
    },

    pobierzOcenyPojazdow(dataod, datado, trasa) {
        return axios({
            method: 'get',
            url: Boolean(trasa) ? URL + 'pojazdow?dataOd=' + dataod + '&dataDo=' + datado + '&idTr=' + trasa : URL + 'pojazdow?dataOd=' + dataod + '&dataDo=' + datado,
        });
    },

    pobierzPlikDoOceny(idOc){
        return axios({
            method: 'get',
            url:  URLCLIENT + 'getPliki/'+idOc,
        });
    }


}


// WEBPACK FOOTER //
// ./src/modules/klienciConfig/oceny/OcenyService.js